import {
  ADD_PLAYLIST_TO_SCREEN,
  ADD_SCREEN_REQUEST,
  ADD_SCREEN_SUCCESS,
  CLIENT_SCREENS_REQUEST,
  CLIENT_SCREENS_SUCCESS,
  COUNT_STATS_OF_SCREEN,
  COUNT_STATS_OF_SCREEN_REQ,
  DELETE_SCREEN,
  FIND_ONE_SCREEN,
  SCREEN_FLAG_OFF,
  SCREEN_REQUEST,
  SCREEN_REQUEST_FAILED,
  SCREEN_REQUEST_SUCCESS,
  SCREEN_STATUS_ACTIVE,
  SCREEN_STATUS_DEACTIVE,
  SCREEN_SOCKET_ONLINE,
  SCREEN_SOCKET_OFFLINE,
  UNCHECK_ASSIGNED_SCREEN,
  UPDATE_SCREEN_SUCCESS,
  ENTER_SUPPORT_CONTEXT,
  LEAVE_SUPPORT_CONTEXT,
} from "../constant";
const initial = {
  screens: [],
  screen: {},
  screen_stats:{},
  statsLoading:false,
  screenLoading: false,
  isLoaded:false,
  isScreenAdded: false,
  isScreenDeleted: false,
  activeScreens:0,
  deactiveScreens:0,
  isAdded: false,
  isScreenUpdated:false,
  isUnChecked: false,
  mac: '',
  clientScreens:[],
  pagination: null
};


export const screenReducer = (state = initial, action) => {
  function findIndex(id){
    let _index= state.screens.findIndex(_screen=>_screen._id==id);
    return _index;
  }
  switch (action.type) {
    case ENTER_SUPPORT_CONTEXT:
    case LEAVE_SUPPORT_CONTEXT:
      // Never show one tenant's rows while another tenant's are loading.
      return { ...initial };
    case SCREEN_FLAG_OFF:
      return {
        ...state,
        isUnChecked: false,
        isAdded: false,
        statsLoading:false,
        isScreenDeleted: false,
        isScreenUpdated:false,
        isLoaded:false,
      }
       case COUNT_STATS_OF_SCREEN_REQ:
        return {
          ...state,
          statsLoading:true,
        }
      case COUNT_STATS_OF_SCREEN:
        return {
          ...state,
          statsLoading:false,
          screen_stats:action.payload
        }
    case ADD_SCREEN_REQUEST:
      return {
        ...state,
        isScreenAdded: true,
      };
    case ADD_SCREEN_SUCCESS: {
      const payload = action.payload;
      if (!payload || typeof payload !== 'object') {
        return { ...state, isScreenAdded: false, isAdded: false, mac: '' };
      }
      let regiScreens = {};
      const now_2 = new Date().getTime();
      const till_2 = 60 * 1000;
      if (now_2 > +payload.lastActive + till_2) {
        regiScreens = { ...payload, onlinesStatus: false };
        state.deactiveScreens += 1;
      } else {
        regiScreens = { ...payload, onlinesStatus: true };
        state.activeScreens += 1;
      }
      const withoutDup = state.screens.filter(
        (s) => String(s._id) !== String(payload._id)
      );
      return {
        ...state,
        screens: [regiScreens, ...withoutDup],
        activeScreens: state.activeScreens,
        deactiveScreens: state.deactiveScreens,
        isScreenAdded: false,
        isAdded: true,
        mac: payload.mac || '',
      };
    }
      case UPDATE_SCREEN_SUCCESS:
        let updatedEditScreens={};
        const now_1 = new Date().getTime();
        let till_1 = 60*1000;
        //  let distance=now + till;
        //  action.payload.forEach(row=> {
          //  if(row.isActive){
           if(now_1 > +action.payload?.lastActive + till_1){
              updatedEditScreens={...action.payload,onlinesStatus:false} 
              // offline_1+=1;
              state.deactiveScreens+=1;
           }
           else{
             updatedEditScreens={...action.payload,onlinesStatus:true}
            //  online_1+=1;
            state.activeScreens+=1;
           }
        state.screens[findIndex(action.payload._id)]={...updatedEditScreens}
        return {
          ...state,
          activeScreens:state.activeScreens,
          deactiveScreens:state.deactiveScreens,
          screens:state.screens,
          mac:action.payload.mac,
          isScreenUpdated:true
        }
    case SCREEN_REQUEST:
      return {
        ...state,
        screenLoading: true,
      };
    case SCREEN_REQUEST_SUCCESS:
      let newScreen = []
      let updatedScreens=[];
      const now = new Date().getTime();
      let till = 60*1000;
      let online=0;
      let offline=0;
      
      // Handle both old format (array) and new format (object with screens and pagination)
      const payload = action.payload;
      const screens = payload.screens || payload; // Handle both formats
      const pagination = payload.pagination;
      
      screens.forEach(row=> {
        if(row?.lastActive!==undefined){
          if(now > +row?.lastActive + till){
             updatedScreens.push({...row,onlinesStatus:false}) 
             offline+=1;
          }
          else{
            updatedScreens.push({...row,onlinesStatus:true})
            online+=1;
          }
        }
       })
      
      return {
        ...state,
        screenLoading: false,
        isLoaded:true,
        screens:updatedScreens,
        activeScreens:online,
        deactiveScreens:offline,
        pagination: pagination || state.pagination
      };
    case SCREEN_REQUEST_FAILED:
      return {
        ...state,
        screenLoading: false
      }
    case FIND_ONE_SCREEN:
      return {
        ...state,
        screen: { ...state.screens.find(s => s._id === action.payload), screenAssigned: false }
      }
    case ADD_PLAYLIST_TO_SCREEN:
      // const assingnedScreenIndex = state.screens.findIndex(s => s._id === action.payload._id);
      state.screens[findIndex(action.payload._id)] = { ...action.payload, screenAssigned: false }
      return {
        ...state,
        screens: state.screens,
        isUnChecked: true
      }
    case UNCHECK_ASSIGNED_SCREEN:
      const findUnCheckScreen = findIndex(action.payload)
      state.screens[findUnCheckScreen] = { ...state.screens[findUnCheckScreen], screenAssigned: true }
      return {
        ...state,
        screens: state.screens,
        isUnChecked: true
      }
   
    case SCREEN_SOCKET_ONLINE: {
      const mac = action.payload;
      if (!mac) return state;
      const norm = String(mac).trim();
      const idx = state.screens.findIndex(
        (s) => s.mac && String(s.mac).trim() === norm
      );
      if (idx < 0) return state;
      const screens = [...state.screens];
      screens[idx] = {
        ...screens[idx],
        onlinesStatus: true,
        lastActive: Date.now(),
      };
      return { ...state, screens };
    }
    case SCREEN_SOCKET_OFFLINE: {
      const mac = action.payload;
      if (!mac) return state;
      const norm = String(mac).trim();
      const idx = state.screens.findIndex(
        (s) => s.mac && String(s.mac).trim() === norm
      );
      if (idx < 0) return state;
      const screens = [...state.screens];
      screens[idx] = { ...screens[idx], onlinesStatus: false };
      return { ...state, screens };
    }
    case SCREEN_STATUS_ACTIVE:
      // const activeStatusIndex = state.screens.findIndex(s => s._id === action.payload._id)
      state.screens[findIndex(action.payload._id)] = { ...action.payload }
      return {
        ...state,
        screens: state.screens,
      };
    case SCREEN_STATUS_DEACTIVE:
      // const DeactiveStatusIndex = state.screens.findIndex(s => s._id === action.payload._id)
      state.screens[findIndex(action.payload._id)] = { ...action.payload }
      return {
        ...state,
        screens: state.screens,
      };
    case DELETE_SCREEN:
      return {
        ...state,
        isScreenDeleted: true,
        screens: state.screens.filter(screen => screen._id !== action.payload)
      }
    case CLIENT_SCREENS_REQUEST:
      return {
        ...state,
        screenLoading: true,
      }
    case CLIENT_SCREENS_SUCCESS:
      let newClientScreens = []
      action.payload.forEach(s => {
        newClientScreens.push({ ...s, screenAssigned: true })
      })
      return {
        ...state,
        screenLoading: false,
        clientScreens: newClientScreens,
      };

    default:
      return state;
  }
};
